import classNames from 'classnames'
import { PropsWithChildren, FC } from 'react'
import { Checkbox } from 'antd'
import { adminJobRequestQuery_jobRequest_parts_linesWithWorkOrderMapping as JobRequestLineType } from '@OpsQuality/JobRequestDetails/__generated__/adminJobRequestQuery'

import Box from '~/core/Box'

import styles from './styles.css'
import ThumbnailImage from './ThumbnailImage'

type ShowMultipleItemsPropsType = {
    checkboxesLocked: boolean
    allButFirstItems: JobRequestLineType[]
}

const ShowMultipleItems: FC<
    PropsWithChildren<ShowMultipleItemsPropsType>
> = props => {
    const { checkboxesLocked, allButFirstItems } = props

    return (
        <>
            {allButFirstItems.map(jobRequestLine => {
                const { id } = jobRequestLine

                return (
                    <Box
                        className={classNames(
                            styles.inspectionItem,
                            styles.inspectionItemWithCheckbox,
                        )}
                        key={id}
                    >
                        <Checkbox
                            value={jobRequestLine}
                            disabled={checkboxesLocked}
                        >
                            <ThumbnailImage jobRequestLine={jobRequestLine} />
                        </Checkbox>
                    </Box>
                )
            })}
        </>
    )
}

export default ShowMultipleItems
